import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';

export default function AutocompleteAsync({
  queryFn,
  queryKey,
  getOptionLabel,
  onChange,
  label = 'Seleccionar',
  initialValue = [],
  multiple = false,
}) {
  const [inputValue, setInputValue] = useState('');
  const [value, setValue] = useState(initialValue);
  const [page, setPage] = useState(1);
  const [options, setOptions] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  const { data, isLoading, isFetching, isSuccess } = useQuery({
    queryKey: [...queryKey, { page, search: inputValue }],
    queryFn: () => queryFn({ page, search: inputValue }),
    staleTime: 1000 * 60 * 5, // opcional: 5 min
  });

  // Actualiza opciones cuando hay datos nuevos
  useEffect(() => {
    if (!isSuccess) return;

    const newOptions = data.centers;
    const more = data.pagination?.hasMore ?? false;

    setOptions((prev) => (page === 1 ? newOptions : [...prev, ...newOptions]));
    setHasMore(more);
  }, [data, isSuccess, page]);

  // Reset página al cambiar input
  useEffect(() => {
    setPage(1);
  }, [inputValue]);

  const handleScroll = (event) => {
    const el = event.currentTarget;
    if (!isFetching && hasMore && el.scrollTop + el.clientHeight >= el.scrollHeight - 100) {
      setPage((prev) => prev + 1);
    }
  };

  return (
    <Autocomplete
      multiple={multiple}
      value={value}
      onChange={(_, newValue) => {
        setValue(newValue);
        onChange?.(newValue);
      }}
      options={options}
      loading={isFetching || isLoading}
      filterOptions={(x) => x} // desactiva filtrado client-side
      onInputChange={(_, val) => setInputValue(val)}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={(a, b) => a?._id === b?._id}
      ListboxProps={{
        onScroll: handleScroll,
        style: { maxHeight: 300, overflow: 'auto' },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isFetching && <CircularProgress size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
